// extracted by mini-css-extract-plugin
export var autoExpand = "_2d-b";
export var container = "_2d-a";
export var containerWidth = "_2d-8";
export var disabled = "_2d-2";
export var error = "_2d-3";
export var fullWidth = "_2d-9";
export var highlightContainer = "_2d-5";
export var inputWrapper = "_2d-0";
export var small = "_2d-1";
export var textarea = "_2d-4";
export var validatedTextarea = "_2d-6";
export var visuallyHidden = "_2d-7";